import React, { FunctionComponent, useEffect, useState } from 'react';
import {
  Classes,
  Button,
  Intent,
  Menu,
  MenuItem,
  TagInput,
  TagProps,
  FormGroup,
} from '@blueprintjs/core';
import { IconNames } from "@blueprintjs/icons";
import { Popover2 } from "@blueprintjs/popover2";

import './InviteUserForm.scss';
import { IRole } from '../../../models';
import { regexEmailMatch } from "../../../utils/text";

type InviteCallback = (data: any) => void;
type ActionCallback = (value?: any) => void;
type Defaults = {[key: string]: string};


type InviteUserFormComponentProps = {
  roles: IRole[];
  defaults?: Defaults;
  pending?: boolean;
  onInvite: InviteCallback;
  onClose: ActionCallback;
};

const InviteUserFormComponent: FunctionComponent<InviteUserFormComponentProps> = ({
  roles, defaults, pending, onInvite, onClose
}: InviteUserFormComponentProps) => {
  const [ actionExecuted, setActionExecuted ] = useState(false);
  const roleOptions = roles?.map((role: any) => ({ name: role.name, value: role.id, id: role.id }));
  const defaultRole = roleOptions.find(role => role.name == 'User')
  const [ activeRole, setActiveRole ]: any = useState(defaultRole)

  useEffect(() => {
    if (actionExecuted && !pending) {
      onClose(true); // user invited
    }
  }, [ actionExecuted, pending ]);

  const onClickInvite = () => {
    setEmails(prevState =>
      prevState.filter(email =>regexEmailMatch(email))
    )
    emails.forEach(email => {
      const data = {
        "email" : email.toLowerCase(),
        "roles" : [activeRole], // it has to be an array
        "first_name" : "",
        "last_name": ""
      }
      onInvite(data)
    })
    setActionExecuted(true);
  }

  function onClickActiveRole (roleId: any) {
    setActiveRole(roleOptions.find(role => role.id == roleId))
  }

  const roleMenuItems = roleOptions.map(role => {
    return <MenuItem text={role.name} id={role.id} onClick={() => onClickActiveRole(role.id)}/>
  });

  const permissionsMenu = (
    <Popover2
      usePortal={false}
      content={
        <Menu>
          {roleMenuItems}
        </Menu>
      }
      placement="bottom-end"
    >
      <Button large={true} intent={Intent.NONE} outlined={false} minimal={false} rightIcon="caret-down">
        {activeRole.name}
      </Button>
    </Popover2>
  );

  const [emails, setEmails] = useState<string[]>(defaults?.email ? [defaults?.email] : []);
  const [showInvalidEmailError,setShowInvalidEmailError] = useState<boolean>(false)
  function onChangeEmails (tagInput:any) {
    const unique:any = [...new Set(tagInput)];
    setEmails(unique)
  }

  const getTagProps = (value: React.ReactNode): TagProps => ({
    intent: regexEmailMatch(value) ? Intent.NONE : Intent.DANGER
  });

  useEffect(() => {
    const containsInvalidEmail = emails.some(email => !regexEmailMatch(email))
    if (containsInvalidEmail){
      setShowInvalidEmailError(true)
    } else {
      setShowInvalidEmailError(false)
    }
  }, [emails])

  return (
    <>
      <div className={Classes.DIALOG_BODY}>
        <div className={`invite-user__form `}> {/*${Classes.FORM_GROUP}*/}
          <FormGroup label="Email(s)">
            <TagInput
              addOnBlur={true}
              fill={true}
              large={true}
              placeholder="Add one or multiple emails"
              onChange={onChangeEmails}
              values={emails}
              tagProps={getTagProps}
            />
            <span className='invite-user__error' style={{visibility: showInvalidEmailError ? 'visible' : 'hidden' }}>
              Emails marked red are not a valid and will be skipped.
            </span>
          </FormGroup>
          <FormGroup label="Role">
            {permissionsMenu}
          </FormGroup>
        </div>
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            intent={Intent.PRIMARY}
            loading={pending}
            onClick={onClickInvite}
            icon={IconNames.SEND_MESSAGE}
            large={true}
          >Invite</Button>
        </div>
      </div>
    </>
  )
};

export default InviteUserFormComponent;
